import { sortBy, indexOf } from 'lodash'

export const sortByOrder = <T>(
  arr: T[],
  order: string[],
  prop: string = 'name'
) => {
  const getIndex = (obj: T) => {
    const idx = indexOf(order, obj[prop])

    // Sort unknowns to the end of the list
    if (idx === -1) {
      return arr.length
    }

    return idx
  }

  return sortBy(arr, getIndex)
}

export const checkValidEmail = (email: string) => {
  if (!email) {
    return false
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
